export default __webpack_public_path__ + "f69011cdc99e99cfc280d8cab6ad52c6.png";